import React from 'react';
import { StyledFolder } from './styles';
import FolderIconSrc from '../../assets/novosicones/Sindico/FolderSimple.svg';

export default function Folder({
  onButtonClick,
  folderName,
  style,
  icon,
  variant = 'default',
  tema = { tema },
}) {
  return (
    <StyledFolder className={variant} onClick={onButtonClick} style={style}>
      <img src={icon ?? FolderIconSrc} />
      <span className='folder-name' title={folderName}>
        {folderName}
      </span>
    </StyledFolder>
  );
}
